import NewExperiencesSection from './NewExperiencesSection';

export default NewExperiencesSection;
